/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-14 00:11:44
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-07 17:08:44
 */
import Vue from 'vue';
import { getStyle } from 'element-ui/src/utils/dom';

/**
 * ak-tooltip-auto-show
 * 当text没有被折叠时，不显示tooltip
 */
export default {
	inserted: function (el, binding, vnode) {
		el.addEventListener('mouseenter', function (e) {
			let defalutSilent = !!Vue.config.silent;
			Vue.config.silent = true;
			vnode.componentInstance.disabled = true;
			const range = document.createRange();
			range.setStart(el, 0);
			range.setEnd(el, el.childNodes.length);
			// 用于固定宽度的超出判断
			const rangeWidth = Math.round(range.getBoundingClientRect().width);
			const paddingHoriz = (parseInt(getStyle(el, 'paddingLeft'), 10) || 0) + (parseInt(getStyle(el, 'paddingRight'), 10) || 0);
			// 用于webkit-box超出判断
			const rangeHeight = Math.round(range.getBoundingClientRect().height);
			const paddingVertical = (parseInt(getStyle(el, 'paddingTop'), 10) || 0) + (parseInt(getStyle(el, 'paddingBottom'), 10) || 0);
			if (
				rangeWidth + paddingHoriz > el.offsetWidth ||
				el.scrollWidth > el.offsetWidth ||
				rangeHeight + paddingVertical > el.offsetWidth ||
				el.scrollHeight > el.offsetHeight
			) {
				vnode.componentInstance.disabled = false;
			}
			Vue.config.silent = defalutSilent;
		});
	},
};
